export const DUMMY_MAYBANK_REDIRECT_URI = 'https://www.maybank2u.com.my';
